<div class="imback" (click)="cancel()"></div>
<div
  class="imdlg"
  role="dialog"
  appDialogFocus
  [attr.aria-label]="S['Import spreadsheet']"
  [attr.aria-busy]="busy() || null"
  (keydown.escape)="cancel()"
>
  <header class="imdlg__head">
    <h2 class="imdlg__title">{{ S['Import spreadsheet'] }}</h2>
    <button class="iconbtn iconbtn--bare" [title]="S['Close']" (click)="cancel()" [disabled]="busy()" [attr.aria-label]="S['Close']">
      <app-icon name="close" size="16" />
    </button>
  </header>
  <p class="imdlg__sub">{{ S['Open a spreadsheet as a new workbook. Your existing workbooks stay in place.'] }}</p>

  <div
    class="imdrop"
    [class.imdrop--over]="dragging()"
    (dragover)="onDragOver($event)"
    (dragleave)="dragging.set(false)"
    (drop)="onDrop($event)"
  >
    <app-icon name="upload" size="26" />
    <p class="imdrop__title">{{ S['Drop a spreadsheet here'] }}</p>
    <p class="imdrop__formats">{{ S['Excel .xlsx / .xls · OpenDocument .ods'] }}<br />{{ S['CSV · TSV'] }}</p>
    <button
      class="btn btn--primary"
      (click)="browse()"
      [disabled]="busy()"
      [attr.aria-label]="busy() ? S['Importing workbook…'] : S['Choose file']"
    >
      {{ busy() ? S['Importing workbook…'] : S['Choose file'] }}
    </button>
  </div>

  @if (error(); as e) {
    <p class="imdlg__error">{{ e }}</p>
  }

  <p class="imdlg__note">
    {{ S['Up to 12 MB, 20 sheets, 5,000 rows and 100 columns per sheet; 100,000 populated cells total. Excel and ODS imports transfer cells, formulas, number formats and merged ranges. Charts, macros and advanced formatting are not imported.'] }}
  </p>

  <footer class="imdlg__foot">
    <button class="btn btn--ghost" (click)="cancel()" [disabled]="busy()" [attr.aria-label]="S['Cancel']">{{ S['Cancel'] }}</button>
  </footer>
</div>

@if (busy()) {
  <!-- The prototype's floating `.file-progress` status, while the file becomes a workbook. -->
  <div class="improgress" role="status">{{ S['Importing workbook…'] }}</div>
}
